import styled from "styled-components";

export const SideBar = styled.div`
  width: 250px;
  left: 100px;
  height: 80%;

  @media only screen and (max-width: 600px) {
    width: 100%;
  }

  h5 {
    text-align: left;
    font-weight: 700;

    @media only screen and (max-width: 600px) {
      text-align: center;
    }
  }

  .links {
    a {
      display: block;
      margin-bottom: 10px;
      text-decoration: none;
      text-align: left;
      color: white;
      font-size: 0.9em;
      font-weight: 800;

      @media only screen and (max-width: 600px) {
        text-align: center;
      }
    }

    @media only screen and (max-width: 600px) {
      width: 100%;
      margin-top: 20px;
      display: grid;
      grid-template-columns: 1fr 1fr;

      svg {
        display: none;
      }
    }
  }

  .active {
    svg {
      fill: var(--bs-danger) !important;

      #Path_10273 {
        fill: var(--bs-danger) !important;
      }
      #Ellipse_1213 {
        fill: var(--bs-danger) !important;
      }
      #Path_10269 {
        fill: var(--bs-danger) !important;
      }
    }

    .link-text {
      color: var(--bs-danger);
      /* font-style: italic; */
    }
  }

  svg {
    max-height: 20px;
    width: 20px;
  }

  .link-text {
    padding-left: 10px;
    text-shadow: 0px 3px 5px #000000;
  }
`;
